/* eslint-disable react/no-array-index-key */
/* eslint-disable react/require-default-props */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-use-before-define */
import React from 'react';
import { ErrorMessage, Field, useFormikContext } from 'formik';

interface SelectProps {
  name: string;
  label: string;
  options: OptionsProps[];
  type?: string;
  placeHolder?: string;
  onChange: React.ChangeEventHandler<HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement>;
}

interface OptionsProps {
  label: string,
  value: string
}

const Select: React.FC<SelectProps> = ({ name, label, options, placeHolder, onChange }) => {
  const formik = useFormikContext();

  const customOnChange = (event: any) => {
    onChange(event);
    formik.handleChange(event);
  };

  return (
    <div>
      <label htmlFor={name} className="fw-bold mb-0">{label}</label>
      <br />
      <Field
        as="select"
        id={name}
        name={name}
        className="select form-select"
        placeholder={placeHolder || ''}
        key={name}
        onChange={customOnChange}
      >
        {options.map((optn, index) => <option value={optn.value} label={optn.label || optn.value} key={optn.value + index} />)}
      </Field>
      <ErrorMessage name={name} component="div" className="error-message" />
    </div>
  );
};

export default Select;
